import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const DashboardSecretaria = () => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true); // para evitar flicker

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      // No hay sesión → redirigir inmediatamente
      navigate("/login", { replace: true });
      return;
    }

    // Aquí podrías hacer una petición rápida para validar el token si quieres
    // (ej: GET /perfil), pero por ahora solo chequeamos existencia
    setIsChecking(false);

  }, [navigate]);

  const cerrarSesion = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    navigate("/login", { replace: true });
  };

  const cards = [
    {
      title: "Gestión de Socios",
      icon: "bi-people-fill",
      variant: "success",
      path: "/GestionSocios",
    },
    {
      title: "Cuotas y Descuentos",
      icon: "bi-currency-dollar",
      variant: "primary",
      path: "/GestionCuotas",
    },
    {
      title: "Gestión de Espacios",
      icon: "bi-calendar-week",
      variant: "warning",
      path: "/GestionEspacios",
    },
    {
      title: "Convenios",
      icon: "bi-briefcase-fill",
      variant: "info",
      path: "/GestionConvenios",
    },
    {
      title: "Gestión de Reservas",
      icon: "bi-bookmark-check",
      variant: "danger",
      path: "/reservas",
    },
    {
      title: "Gestión de Eventos",
      icon: "bi-calendar-event",
      variant: "secondary",
      path: "/GestionEventos",
    },
    {
  title: "Gestión de Cuotas",
  icon: "bi-currency-dollar",
  variant: "success",
  path: "/AdminCuotas",
},
   {
  title: "Gestión de Facultades",
  icon: "bi-building",
  variant: "primary",
  path: "/Facultades",
},
 {
  title: "Reservar Espacios",
  icon: "bi-calendar-check",
  variant: "secondary",
  path: "/ReservarEspacio",
},
    {
      title: "Reportes",
      icon: "bi-graph-up",
      variant: "dark",
      path: "/reportes",
    },

  ];

  // Mientras verificamos → mostramos un loading simple
  if (isChecking) {
    return (
      <div className="min-vh-100 bg-light d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }}></div>
          <p className="mt-3 text-muted">Verificando sesión...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100 bg-light">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow">
        <div className="container-fluid px-4 px-md-5">
          <a className="navbar-brand fw-bold fs-4 d-flex align-items-center" href="#">
            <i className="bi bi-building-gear me-2"></i>
            ADUTEM | Administración
          </a>

          <div className="ms-auto d-flex align-items-center gap-4">
            <div className="d-flex align-items-center text-white">
              <i className="bi bi-person-circle fs-5 me-2"></i>
              <span>Secretaría</span>
            </div>

            <button className="btn btn-outline-light px-4" onClick={cerrarSesion}>
              <i className="bi bi-box-arrow-right me-2"></i>
              Cerrar sesión
            </button>
          </div>
        </div>
      </nav>

      {/* Contenido principal */}
      <div className="container-fluid px-4 px-md-5 py-5">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5">
          <h3 className="fw-bold mb-3 mb-md-0">Panel Principal</h3>
          <small className="text-muted">
            {new Date().toLocaleDateString("es-ES", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </small>
        </div>

        <div className="row g-4">
          {cards.map((card, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-4 col-xl-3">
              <div
                className={`card h-100 shadow border-0 text-white bg-${card.variant}`}
                style={{ cursor: "pointer" }}
                onClick={() => navigate(card.path)}
              >
                <div className="card-body d-flex flex-column justify-content-center align-items-center text-center py-5">
                  <i className={`${card.icon} display-1 mb-4`}></i>
                  <h5 className="card-title fw-bold mb-1">{card.title}</h5>
                  <small className="opacity-75">Acceder</small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardSecretaria;